/** 曲一覧のフィルタ・並び順の条件 */

export type LyricsPresence = 'all' | 'with' | 'without'
export type LyricsTiming = 'word' | 'line' | 'none'
export type DownloadState = 'all' | 'downloaded' | 'not_downloaded'

export type SongsFilter = {
  artistTagIds: number[]
  title: string
  lyricsQuery: string
  lyricsPresence: LyricsPresence
  lyricsTimings: LyricsTiming[]
  releaseYearMin: string
  releaseYearMax: string
  downloadState: DownloadState
}

export const EMPTY_SONGS_FILTER: SongsFilter = {
  artistTagIds: [],
  title: '',
  lyricsQuery: '',
  lyricsPresence: 'all',
  lyricsTimings: [],
  releaseYearMin: '',
  releaseYearMax: '',
  downloadState: 'all',
}

/** 何らかの絞り込みが有効かどうか */
export const isSongsFilterActive = (filter: SongsFilter): boolean =>
  filter.artistTagIds.length > 0 ||
  filter.title.trim() !== '' ||
  filter.lyricsQuery.trim() !== '' ||
  filter.lyricsPresence !== 'all' ||
  filter.lyricsTimings.length > 0 ||
  filter.releaseYearMin.trim() !== '' ||
  filter.releaseYearMax.trim() !== '' ||
  filter.downloadState !== 'all'

export type SortKey = 'release' | 'title' | 'artist'

export type SongsSort = {
  key: SortKey
  descending: boolean
}

export const SORT_OPTIONS: { key: SortKey; label: string }[] = [
  { key: 'release', label: '配信日順' },
  { key: 'title', label: '曲名順' },
  { key: 'artist', label: '歌手名順' },
]

/** 配信日順は新しいものを先に出すため、デフォルトを降順にする */
export const defaultDescending = (key: SortKey): boolean => key === 'release'

export const DEFAULT_SONGS_SORT: SongsSort = { key: 'title', descending: false }
